// extracted by mini-css-extract-plugin
export default {"main":"ListTranslationsViewElement_main__WGK0W","cell":"ListTranslationsViewElement_cell__mTKeG","actions":"ListTranslationsViewElement_actions__aKcnU"};